import { guid } from '@/mixins/guid';

export default params => ({
  _id: guid.methods.guid(),
  created: new Date().toISOString(),
  name: params.name,
  alias: params.name,
  thumbnail: `${process.env.S3_ASSETS_URL}mock-images/default-images/mock-group.svg`,
  items: [],
  categories: [],
  pageId: null,
  description: null,
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/groups/new-group.js